import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { formatDate } from '@otp/utils';
export const DateColumn = ({ date, withTime = false, }) => {
    if (withTime) {
        return _jsx(_Fragment, { children: formatDate(date, 'auto') });
    }
    return _jsx(_Fragment, { children: formatDate(date) });
};
